import { render } from "./regular-amendment-text-display.vue?vue&type=template&id=4e8c3286"
import script from "./regular-amendment-text-display.vue?vue&type=script&lang=js"
export * from "./regular-amendment-text-display.vue?vue&type=script&lang=js"

import "./regular-amendment-text-display.vue?vue&type=style&index=0&id=4e8c3286&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__